// @mui
import { styled } from '@mui/material/styles';
import { ListItemIcon, ListItemButton } from '@mui/material';

// ----------------------------------------------------------------------

export const StyledNavItem = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 52,
  position: 'relative',
  textTransform: 'capitalize',
  color: theme.palette.text.secondary,
  borderRadius: 12,
  margin: '4px 0',
  padding: '8px 16px',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
    transform: 'translateX(4px)',
  },
  '&.active': {
    backgroundColor: theme.palette.primary.lighter,
    color: theme.palette.primary.main,
    fontWeight: 600,
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      width: 3,
      height: 24,
      backgroundColor: theme.palette.primary.main,
      borderRadius: '0 2px 2px 0',
    },
  },
}));

export const StyledNavItemIcon = styled(ListItemIcon)(({ theme }) => ({
  width: 24,
  height: 24,
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 40,
  marginRight: 12,
  '& svg': {
    width: 20,
    height: 20,
  },
}));
